import React from "react";
import { useTranslation, Trans } from "react-i18next";

const Resources = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div
      id={id}
      className="w-full py-28 px-2 sm:px-6 lg:px-16 xl:px-32 2xl:px-64 text-white bg-gray-800"
    >
      <div className="max-w-screen-2xl mx-auto">
        <div className="my-4 flex flex-col gap-6" data-aos="fade-right">
          <p className="text-gray-300  mt-2 sm:mt-4">
            {t("resources.p1")}
          </p>
          <p className="text-gray-300  mt-1 sm:mt-2">
            {t("resources.p2")}
          </p>
          <p className="text-gray-300  mt-1 sm:mt-2">
            {t("resources.p3")}
          </p>
          <p className="text-gray-300  mt-1 sm:mt-2">
            <Trans
              i18nKey="resources.p4"
              components={[<span className="text-[#00df9a] font-semibold" />]}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Resources;
